import Vue from "vue"
import { authDict } from "@/utils/authDiact"

const permissionDirective = function(Vue){
    Vue.directive('permission',{
        inserted(el,binding){
            let { value:needAuthRole } = binding
            const haveAuthRole = window.localStorage.getItem('authRole')?JSON.parse(window.localStorage.getItem('authRole')):null
            if(needAuthRole&&authDict[haveAuthRole]<authDict[needAuthRole]){
                el.style.display="none" 
            }else{
                el.style.display="inline-block" 
            }
        }
    })
}



export default permissionDirective